import { EventGuest } from "../../redux/features/event/event.types";
import { TicketColor } from "../../utils/types";
import { Pill } from "../pill";
import { ProfileIcon } from "./profilePic";

export const GuestCard = ({
  className,
  name,
  email,
  otherText,
  otherDetails,
  timeAgo,
  showTicket = true,
  hideEmailOnMobile = false,
  guest,
  ticketColor,
}: {
  className?: string;
  name: string;
  email?: string;
  otherText?: string;
  timeAgo?: string;
  showTicket?: boolean;
  otherDetails?: string;
  hideEmailOnMobile?: boolean;
  guest?: EventGuest;
  ticketColor?: TicketColor;
}) => {
  return (
    <div className="flex items-start gap-2">
      <div
        className={`flex min-w-fit flex-col gap-2 md:w-full md:flex-row md:items-center ${className}`}
      >
        <ProfileIcon img="" dimension={32} className="" />

        <div className="flex flex-wrap items-center gap-0 text-sm text-grey-600">
          <div className="flex flex-col">
            <span className="font-bold text-grey-900">{name}</span>
            {otherDetails && (
              <span className="text-sm !font-normal text-grey-600">
                {otherDetails}
              </span>
            )}
          </div>

          {email && (
            <>
              <span className={`${hideEmailOnMobile && "hidden"} md:flex`}>
                ∙
              </span>
              <span className={`${hideEmailOnMobile && "hidden"} md:flex`}>
                {email}
              </span>
            </>
          )}
        </div>

        {otherText && <p className="text-sm text-grey-600">{otherText}</p>}

        {showTicket && (
          <div className="hidden flex-1 flex-wrap justify-end gap-1 md:flex">
            {guest?.tickets?.map((t, idx) => {
              const pillColor = ticketColor?.find(
                (tc) => tc.ticketId === (t?.ticketId?._id ?? t?.ticketId),
              )?.color;

              return (
                <Pill
                  text={`x${t?.quantity} ${t?.ticketId?.name}`}
                  variation="green"
                  className={`!line-clamp-1 !w-full !min-w-0 !max-w-fit !overflow-hidden !text-left`}
                  key={`${t?.ticketId}-${idx}`}
                  style={
                    ticketColor
                      ? {
                          backgroundColor: pillColor
                            ? pillColor?.split(",")[1]
                            : undefined,
                          color: pillColor
                            ? pillColor?.split(",")[0]
                            : undefined,
                        }
                      : undefined
                  }
                />
              );
            })}
          </div>
        )}

        {timeAgo ? (
          <p className="w-fit text-sm text-grey-600">{timeAgo}</p>
        ) : undefined}
      </div>

      {showTicket && (
        <div className="flex flex-1 flex-wrap justify-end gap-1 md:hidden">
          {guest?.tickets?.map((t, idx) => {
            const pillColor = ticketColor?.find(
              (tc) => tc.ticketId === (t?.ticketId?._id ?? t?.ticketId),
            )?.color;

            return (
              <Pill
                key={`${t?.ticketId}-${idx}`}
                text={`x${t?.quantity} ${t?.ticketId?.name}`}
                variation="green"
                className={`!line-clamp-1 !w-full !min-w-0 !max-w-fit !overflow-hidden !text-left`}
                style={
                  ticketColor
                    ? {
                        backgroundColor: pillColor
                          ? pillColor?.split(",")[1]
                          : undefined,
                        color: pillColor ? pillColor?.split(",")[0] : undefined,
                      }
                    : undefined
                }
              />
            );
          })}
        </div>
      )}
    </div>
  );
};
